/*
 * Read more functionality
 */

window.readMore = function readMore() {

    var read_more_wrap = $('.js_readMoreDescWrap'),
        plus_icon_svg = '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="plus" class="svg-inline--fa fa-plus fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M368 224H224V80c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h144v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V288h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path></svg>',
        minus_icon_svg = '<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="minus" class="svg-inline--fa fa-minus fa-w-12" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M368 224H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"></path></svg>',
        read_more = plus_icon_svg + 'Read More',
        read_less = minus_icon_svg + 'Read Less';

    read_more_wrap.each(function () {
        var $this = $(this),
            capped_height = ($this.data('capped-height') ? $this.data('capped-height') : 60),
            initial_height = $this.height(),
            read_more_button = $this.parents().nextAll('.js_readMoreButton');

        if (initial_height < capped_height) {

            $this.css({
                height: 'auto',
                overflow: 'hidden'
            });

            read_more_button.hide();
        } else {
            $this.css({
                height: capped_height + 'px',
                overflow: 'hidden'
            });

            read_more_button.show();
        }

        read_more_button.on('click', function (e) {
            e.preventDefault();

            if ($this.outerHeight() <= capped_height + 10) {

                $this.animate({
                    height: initial_height
                });

                read_more_button.html(read_less);
            } else {
                $this.animate({
                    height: capped_height + 'px'
                });

                read_more_button.html(read_more);
            }
        });
    });
}

$(document).ready(function () {
    'use strict';

    if ($('.js_readMoreDescWrapTablet').length && matchesMediaQuery(0, 1040)) {
        readMore();
    }

    if ($(window).width() <= window.breakpoints.mobile && $('.js_readMoreDescWrapTablet').length === 0) {
        readMore();
    }
});